import type { ComponentProps } from 'react';

import { Container, Flex } from '@change-corgi/design-system-legacy/layout';

export const ActionBar: React.FC<ActionBarProps> = ({ children, ...rest }) => {
	return (
		<Flex
			sx={{
				backgroundColor: 'sunrise.semantic.background.base',
				border: '1px solid',
				borderColor: 'sunrise.semantic.stroke.weaker',
				position: 'fixed',
				left: 0,
				right: 0,
				bottom: 0,
				zIndex: 1,
			}}
			{...rest}
		>
			<Container sx={{ maxWidth: '620px', p: 'sunrise.4' }}>{children}</Container>
		</Flex>
	);
};

type ActionBarProps = ComponentProps<typeof Flex>;
